import { v4 as uuidv4 } from 'uuid';
import Element from "../../../../components/base/element";
import Form from "../../../../components/base/forms/form";
import SubmitButton from "../../../../components/base/forms/submit-button";
import {AnalyticsService} from "../../../../services/analytics-service";

export default class ProftestScreen extends Element {
	constructor(props) {
		super(props);
		this.$root = document.getElementById('proftestScreen');
		this.$progressBarFill = document.getElementById('porftestProgressBarFill');
		this.$question = document.getElementById('proftestQuestion');
		this.$yesTrigger = document.getElementById('proftestYesTrigger');
		this.$noTrigger = document.getElementById('proftestNoTrigger');

		this.dataManager = null;
		this.currentQuestionIndex = 0;
		this.answers = [];
		this.answersDetails = [];

		this.yesAnswerHandler = this.yesAnswerHandler.bind(this);
		this.noAnswerHandler = this.noAnswerHandler.bind(this);
		this.keyboardControlsHandler = this.keyboardControlsHandler.bind(this);

		this.COMPLETE_TEST_EVENT = 'completeTest';
	}

	init(dataManager) {
		this.dataManager = dataManager;
		this.currentQuestionIndex = 0;
		this.answers = [];
		this.answersDetails = [];

		this.setQuestion();
		this.animateProgressBar();
		super.init();
	}

	get questions() {
		return this.dataManager.questions;
	}

	get sections() {
		return this.dataManager.sections;
	}

	setQuestion() {
		const question = this.questions[this.currentQuestionIndex];

		if (question) {
			this.$question.textContent = question.question;
		}
	}

	addEventListeners() {
		this.removeEventListeners();

		this.$yesTrigger.addEventListener('click', this.yesAnswerHandler);
		this.$noTrigger.addEventListener('click', this.noAnswerHandler);
		window.addEventListener('keydown', this.keyboardControlsHandler);
	}

	removeEventListeners() {
		this.$yesTrigger.removeEventListener('click', this.yesAnswerHandler);
		this.$noTrigger.removeEventListener('click', this.noAnswerHandler);
		window.removeEventListener('keydown', this.keyboardControlsHandler);
	}

	yesAnswerHandler() {
		this.makeAnswer(true);
	}

	noAnswerHandler() {
		this.makeAnswer(false);
	}

	keyboardControlsHandler(e) {
		if (e.key === 'ArrowLeft') {
			this.makeAnswer(true);
		} else if (e.key === 'ArrowRight') {
			this.makeAnswer(false);
		}
	}

	makeAnswer(answerVariant) {
		const currentQuestion = this.questions[this.currentQuestionIndex];
		const isCorrect = currentQuestion.answer === answerVariant;

		const answerInfo = this.answers.find(item => {
			return item.sectionId === currentQuestion.sectionId;
		});

		if (!answerInfo) {
			const sectionId = currentQuestion.sectionId;
			const section = isNaN(+sectionId) ? sectionId : this.getCourseName(sectionId);

			this.answers.push({
				sectionId,
				section,
				result: isCorrect ? 1 : 0
			});
		} else if (answerInfo && isCorrect) {
			answerInfo.result++;
		}

		this.answersDetails.push(Object.assign(
			{}, currentQuestion,
			{answer: answerVariant, rightAnswer: currentQuestion.answer}
		));

		this.currentQuestionIndex++;

		if (this.currentQuestionIndex === this.questions.length) {
			return this.completeTest();
		}

		this.setQuestion();
		this.animateProgressBar();
	}

	completeTest() {
		this.removeEventListeners();
		const result = this.getResult();
		this.dataManager.answers = result;
		this.initForm();
	}

	getResult() {
		const result = this.answers.map(item => {
			const resultItem = Object.assign({}, item);
			const total = this.questions.filter((q) => q.sectionId === item.sectionId).length;

			resultItem.rate = (resultItem.result / total).toFixed(2);
			return resultItem;
		});

		result.sort((a, b) => {
			return +b.rate - +a.rate;
		});

		return result;
	}

	getCourseName(id) {
		const course = this.sections.find(item => item.sectionId === id);
		return course.title;
	}

	animateProgressBar() {
		const rate = Math.round((this.currentQuestionIndex) / this.questions.length * 100);
		this.$progressBarFill.style.transform = `translateX(${rate}%)`;
	}

	initForm() {
		if (this.proftestForm) {
			this.proftestForm.setInitialValues();
			// this.proftestForm.secondarySubmitButton.enable();
			this.$root.classList.add('-form');
			return;
		}

		try	{
			this.proftestForm = new Form({
				formId: 'proftest',
				uri: '/2.0/courses/registration',
				data: {
					type: 'protest',
					answersDetails: this.answersDetails,
					fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
					fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null
				},
				// submitButton: new SubmitButton({
				// 	$root: document.getElementById('proftestFormSubmitButton'),
				// 	data: { type: 'protest-phone' }
				// }),
				// secondarySubmitButton: new SubmitButton({
				// 	$root: document.getElementById('proftestFormSecondarySubmitButton'),
				// 	data: { type: 'protest-skip', tel: '' }
				// }),
				subscriptions: [
					{
						event: 'beforeSubmit',
						callback: () => {
							const conversionId = uuidv4();
							const owoxUserId = costorage.get('ouid');
							let answers = this.dataManager.answers.map(item => {
								const result = Math.round(+item.rate * 100);
								return {
									sectionId: item.sectionId,
									section: item.section,
									result: result
								};
							});
							this.proftestForm.addData({ answers });

							this.proftestForm.addData({ conversionId });

							if (owoxUserId) {
								this.proftestForm.addData({ owoxUserId });
							}

							// Send GTM event
							const dataLayerEventData = {
								event: 'prof_test_form',
								formId: this.proftestForm.formId,
								phone: this.proftestForm.data.tel,
								email: this.proftestForm.data.email,
								conversion_id: conversionId
							};

							const $formTitle = this.proftestForm.$root.querySelector('.form_title');

							if ($formTitle) {
								dataLayerEventData.formName = $formTitle.textContent;
							}

							AnalyticsService.sendEvent('prof_test_form', dataLayerEventData);
						}
					},
					{
						event: 'submitComplete',
						callback: () => {
							this.dispatchEvent(this.COMPLETE_TEST_EVENT);
							this.$root.classList.remove('-form');
						}
					}
				]
			});
		} catch (err) {
			console.error('Proftest form: ', err);
		}

		this.$root.classList.add('-form');
	}
}